module.exports = __webpack_public_path__ + "img/photo.257ce05d.svg";